/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import endpointConfig from "../config/endpoints.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { IMPORT_STUDENTS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUserUploadServiceMethods extends IPluginMethodMap {
  createUserUpload(args: any): any;
}

export class UserUploadService implements IAgentPlugin {
  readonly methods: IUserUploadServiceMethods;

  constructor() {
    this.methods = {
      createUserUpload: this.createUserUpload.bind(this),
    };
  }

  async createUserUpload(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: IMPORT_STUDENTS,
          variables: {
            users: args?.validData,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.importUsers) {
          return {
            ...res?.data?.importUsers,
          };
        }
      }
    } catch (err: any) {
      return err;
    }
    // try {
    //   // const res = await axios.post(endpointConfig?.createUserUpload, {
    //   //   data: args?.validData,
    //   // });
    //   // console.log("created group =>", res?.data);
    //   // return res?.data;
    //   return true;
    // } catch (err: any) {
    //   console.log("Error in create group", err?.message);
    // }
  }
}
